import React__default from 'react';
import { ThreeDots } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Button } from '../../Button/src/Button.js';
import { Icon } from '../../Icon/src/Icon.js';
import modules_7fc2511b from '../styles/PaginationButton.module.less.js';

const PaginationButton = (props) => {
    const { pageNumber, currentPage, onPageChanged } = props;
    const cx = useStyles(modules_7fc2511b);
    if (typeof pageNumber === 'string') {
        return (React__default.createElement(Button, { variant: "text", className: cx('dots') },
            React__default.createElement(Icon, { icon: React__default.createElement(ThreeDots, null) })));
    }
    const page = pageNumber - 1;
    return (React__default.createElement(Button, { "data-qa": "PaginationButton", onClick: () => onPageChanged(page), variant: page === currentPage ? 'outlined' : 'text', color: page === currentPage ? 'blue' : 'dark', 
        // eslint-disable-next-line @typescript-eslint/naming-convention
        className: cx({ 'selected-page': page === currentPage }, 'pagination-button') }, pageNumber));
};

export { PaginationButton };
//# sourceMappingURL=PaginationButton.js.map
